import { useContext } from 'react';

import { authContext } from '../contexts/auth';
import { IAuthContext } from '../contexts/auth/interfaces';

const useAuth = () => useContext<IAuthContext>(authContext);

export default useAuth;
